import { CommerceToolsApi } from '@grandvisionhq/commercetools';
import { getJoinedLocalizedAttrValues, getLocalizedAttrValue, getAttrValue } from '@grandvisionhq/utils';

const getFacetColor = (variant, productType)=>{
    if (!productType) {
        return undefined;
    }
    if (CommerceToolsApi.isFrames(productType) || CommerceToolsApi.isSunglasses(productType)) {
        const frameColor = getJoinedLocalizedAttrValues(variant, 'frameColor', 'en');
        const lensColor = getLocalizedAttrValue(variant, 'lensColor', 'en');
        return !lensColor ? frameColor : `${lensColor} / ${frameColor}`;
    }
    if (CommerceToolsApi.isAccessories(productType)) {
        const accessoryColor = getJoinedLocalizedAttrValues(variant, 'accessoryColor', 'en');
        return accessoryColor;
    }
    if (CommerceToolsApi.isSolutions(productType)) {
        const volume = getAttrValue(variant, 'packageOption');
        return `${volume}`;
    }
};

export { getFacetColor };
//# sourceMappingURL=get-facet-color.js.map
